<template>
  <div class="row m-0" v-if="can_access('deal','view')">
    <div class="col-sm-12 p-0 mb-2" v-if="can_access('deal','modify')">
      <input type="checkbox"
        id="forcecalc" :checked="forcecalc" v-model="forcecalc"
      />
      <label for="forcecalc">Recheck Charges</label>
    </div>
    <TableView :col="columns" :getData="getData" v-if="showTable"/>          
  </div> 
</template>
<script>
import common from '@/assets/js/common.js';
export default {
  components: {
    TableView : () => import('@/components/Common/DataTable/Table') ,
  },
  mixins: [common],
  props: ['report_date'],
  data(){
  	return {
      forcecalc: false,
      showTable: true,
      columns: (() => {
        const cols = [
          { title: 'CUSTODIAN NAME', field: 'custodian_name', thComp: 'FilterTh', tdStyle: {'text-decoration':'underline dashed'},sortable: true, tdOnClick:this.ShowDealDetail},
          { title: 'COUNTERPARTY NAME', field: 'counterparty_name', thComp: 'FilterTh' },
          { title: 'CAPACITY', field: 'capacity', thComp: 'FilterTh', tdStyle: {padding: "0.8rem !important"}},
          { title: 'ACCOUNT NUMBER', field: 'account_number', thComp: 'FilterTh'},
          { title: 'FIRSTNAME', field: 'first_name', sortable: true },
          { title: 'PORTFOLIO CODE', field: 'portfolio_code', sortable: true },
          { title: 'PORTFOLIO TYPE', field: 'portfolio_type', thComp: 'FilterTh'},
          { title: 'SECURITY', field: 'stock', nested: 'security'},
          { title: 'EXCHANGE', field: 'stock', nested: 'exchange_name', sortable: true },
          { title: 'ISSUER NAME', field: 'stock', nested: 'issuer_name', thComp: 'FilterTh', sortable: true,},
          { title: 'ISIN', field: 'stock', nested: 'isin'},
          { title: 'SEDOL', field: 'stock', nested: 'sedol'},
          { title: 'TICKER', field: 'stock', nested: 'tidm', thComp: 'FilterTh'},
          { title: 'SIDE', field: 'type', thComp: 'FilterTh'},
          { title: 'QUANTITY', field: 'total_quantity', thComp: 'FilterTh', tdComp: 'Number', 'floatLength': 2},
          { title: 'TRADE PRICE', field: 'trade_price', sortable: true , tdComp: 'Number'},
          { title: 'CURRENCY', field: 'currency', sortable: true},
          { title: 'TRADE VALUE', field: 'trade_value', thComp: 'FilterTh', tdComp: 'Number'},
          { title: 'TRADE DATE', field: 'trade_date', thComp: 'FilterTh'},
          { title: 'SETTLEMENT DATE', field: 'settlement_date'},
          { title: 'BUSINESS DATE', field: 'business_date'},
          { title: 'EXECUSION FEE', field: 'execusion_fee', thComp: 'FilterTh'},
          { title: 'PTM LEVY', field: 'exchange_fee', thComp: 'FilterTh'},
          { title: 'COMMISSION VALUE', field: 'commission_value', thComp: 'FilterTh', tdComp: 'Number', 'floatLength': 2},
          { title: 'GST', field: 'gst', sortable: true , tdComp: 'Number'},
          { title: 'NDFRATE', field: 'ndf_rate', sortable: true, tdComp: 'Number'},
          { title: 'ACCRUED INTEREST', field: 'accrued_interest', thComp: 'FilterTh'},
          { title: 'NET AMOUNT', field: 'net_amount', thComp: 'FilterTh', tdComp: 'Number'},
          { title: 'E-BROKER CODE', field: 'e-brokercode', thComp: 'FilterTh'},
          { title: 'E-COMMISSION', field: 'e-commission', thComp: 'FilterTh', tdComp: 'Number', 'floatLength': 2},
          { title: 'E-FEE AMOUNT', field: 'e-feeamount', sortable: true , tdComp: 'Number'},
          { title: 'TICKET NUMBER', field: 'ticket_number', sortable: true, tdComp: 'Number'},
          { title: 'CLIENT REF NUMBER', field: 'client_ref_no', thComp: 'FilterTh'},
        ]
        const groupsDef = {
          Normal: [],
          Sortable: [],
          Extra: ['Operation']
        }
        return cols.map(col => {
          if(!this.can_view_field('deal', col.nested?col.nested:col.field) && col.title != 'Operation') col.visible = false;
          Object.keys(groupsDef).forEach(groupName => {
            if (groupsDef[groupName].includes(col.title)) {
              col.group = groupName
            }
          })
          return col
        })
      })(),
  	}
  },
  watch: {
    forcecalc: function(newValue){
      this.showTable = false;
      this.$nextTick(()=>{
        this.forcecalc = newValue;
        this.showTable = true;
      });
    }
  },
  created() {
  },
  methods: {
    async getData(query, filter) {
      var { limit = 100, offset = 0, sort = 'trade_date', order = '' } = JSON.parse(JSON.stringify(query));
      //filter['has_trade'] = 1;
      this.columns.forEach(col => {
        if (query[col.field]) {
          filter[col.field] = query[col.field];
        }else if(typeof filter[col.field] != 'undefined'){
          delete filter[col.field];
        }
      });
      //filter['trade_date'] = {from_date: this.report_date[0], to_date: this.report_date[1]};
      //filter['type'] = "BUY,SELL";
      let para = '';
      if(this.forcecalc) para = '&force=1';
      let uri = 'get_auto_charges_list?from_date='+this.report_date[0]+'&to_date='+this.report_date[1]+para;
      this.$emit('setFilter', filter);
      return await this.call_axios(uri);
    }
  }
}
</script>
<style>
.header-bar{
  text-align: center;
  vertical-align: middle !important;
  font-weight: 700;
  color:#fff;
  padding: 10px 0 0 0;
}
</style>